import { axios } from '@/utils/request'

const api = {
  Pre: '/admin.php/Member/pre',
  List: '/admin.php/Member/getList',
  SearchUser: '/admin.php/Member/getListBySearch',
  Add: '/admin.php/Member/add',
  Update: '/admin.php/Member/update',
  UpdateState: '/admin.php/Member/updateUserState',
  updateUserStateBatch: '/admin.php/Member/updateUserStateBatch',
  TeacherList: '/admin.php/Member/getTeacherList',
  Detail: '/admin.php/Member/detail',
  TeacherDetail: '/admin.php/Member/teacherDetail',
  AddTeacher: '/admin.php/Member/addTeacher',
  UpdateTeacher: '/admin.php/Member/updateTeacher',
  UpdateTeacherState: '/admin.php/Member/updateTeacherState',
  updateTeacherStateBatch: '/admin.php/Member/updateTeacherStateBatch',
}

// 预加载
export function getUserPre () {
  return axios({
    url: api.Pre,
    method: 'get'
  })
}

export function postAdd (parameter) {
  return axios({
    url: api.Add,
    method: 'post',
    data: parameter
  })
}

export function postUpdate (parameter) {
  return axios({
    url: api.Update,
    method: 'post',
    data: parameter
  })
}

export function updateUserState (parameter) {
  return axios({
    url: api.UpdateState,
    method: 'post',
    data: parameter
  })
}

export function updateUserStateBatch (parameter) {
  return axios({
    url: api.updateUserStateBatch,
    method: 'post',
    data: parameter
  })
}

export function getUserList (parameter) {
  return axios({
    url: api.List,
    method: 'get',
    params: parameter
  })
}

export function getUserDetail (parameter) {
  return axios({
    url: api.Detail,
    method: 'get',
    params: {
      uid: parameter
    }
  })
}

export function getTeacherList (parameter) {
  return axios({
    url: api.TeacherList,
    method: 'get',
    params: parameter
  })
}

export function getTeacherDetail (parameter) {
  return axios({
    url: api.TeacherDetail,
    method: 'get',
    params: {
      tid: parameter
    }
  })
}

export function postAddTeacher (parameter) {
  return axios({
    url: api.AddTeacher,
    method: 'post',
    data: parameter
  })
}

export function postUpdateTeacher (parameter) {
  return axios({
    url: api.UpdateTeacher,
    method: 'post',
    data: parameter
  })
}

export function updateTeacherState (parameter) {
  return axios({
    url: api.UpdateTeacherState,
    method: 'post',
    data: parameter
  })
}

export function updateTeacherStateBatch (parameter) {
  return axios({
    url: api.updateTeacherStateBatch,
    method: 'post',
    data: parameter
  })
}

export function searchUser (parameter) {
  return axios({
    url: api.SearchUser,
    method: 'get',
    params: parameter
  })
}
